__turbopack_context__.v({
  "container": "site-breadcrumbs-module__p2FR0a__container",
});
